const updates = [
  {
    time: '5分钟前',
    title: '知名美食博主深夜醉酒直播全程翻车，粉丝直呼幻灭',
    badge: '爆',
    badgeColor: 'bg-primary-500 text-white',
  },
  {
    time: '28分钟前',
    title: '某S+级综艺录制现场突发冲突，两位导师当场翻脸',
    badge: '热',
    badgeColor: 'bg-accent-500 text-white',
  },
  {
    time: '1小时前',
    title: '百万粉穿搭博主被扒全身假货，品牌方集体解约',
    badge: '新',
    badgeColor: 'bg-foreground-700 text-white',
  },
  {
    time: '2小时前',
    title: '酒店猛料第二弹：走廊监控拍下多位艺人深夜串门',
    badge: '热',
    badgeColor: 'bg-accent-500 text-white',
  },
  {
    time: '3小时前',
    title: '某顶流女星前助理匿名爆料：私下脾气极差殴打工作人员',
    badge: '爆',
    badgeColor: 'bg-primary-500 text-white',
  },
  {
    time: '5小时前',
    title: '网红情侣分手内幕：男方疑似同时交往三位女网红',
    badge: null,
    badgeColor: '',
  },
  {
    time: '8小时前',
    title: '选秀节目投票数据泄露，冠军早已内定实锤曝光',
    badge: null,
    badgeColor: '',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-950 mb-10 text-center">
          24小时实时快讯
        </h2>
        <div className="relative pl-8">
          <div className="absolute left-[11px] top-2 bottom-2 w-px bg-primary-200"></div>
          {updates.map((item, idx) => (
            <div key={idx} className="relative pb-7 last:pb-0">
              <div className="absolute left-[-32px] top-1.5 w-3.5 h-3.5 rounded-full bg-primary-500 border-4 border-background-50"></div>
              <div className="flex items-center gap-2 mb-1.5 flex-wrap">
                <span className="text-xs text-foreground-400 font-medium">{item.time}</span>
                {item.badge && (
                  <span className={`px-2 py-0.5 rounded-full text-[10px] font-bold ${item.badgeColor}`}>
                    {item.badge}
                  </span>
                )}
              </div>
              <h3 className="text-sm md:text-base font-bold text-foreground-800 leading-snug">
                {item.title}
              </h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}